"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBalancerV1Quote = void 0;
var ethers_1 = require("ethers");
var bignumber_js_1 = require("bignumber.js");
var sor_1 = require("@balancer-labs/sor");
var common_1 = require("@setprotocol/index-coop-contracts/dist/utils/common");
var constants_1 = require("../../../utils/constants");
var types_1 = require("../../types");
var dependencies_1 = __importDefault(require("../../dependencies"));
var ETH_ADDRESS = dependencies_1.default.ETH_ADDRESS;
// Usage note, targetPriceImpact should be the impact including fees! Balancer pool fees can change and it's not easy to extract from the data
// we have so put in a number that is net of fees.
function getBalancerV1Quote(provider, tokenAddress, targetPriceImpact) {
    return __awaiter(this, void 0, void 0, function () {
        var sor, inputAmount, _a, returnAmountV1, marketSpV1Scaled, effectivePrice, priceImpact, priceImpactRatio;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sor = new sor_1.SOR(provider, toBigNumberJS(common_1.gWei(100)), 3, // Max 3 pools used
                    1, // ChainId = mainnet (1)
                    "https://storageapi.fleek.co/balancer-bucket/balancer-exchange/pools");
                    return [4 /*yield*/, sor.fetchPools()];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, sor.setCostOutputToken(tokenAddress)];
                case 2:
                    _b.sent(); // Set cost to limit small trades
                    inputAmount = toBigNumberJS(common_1.ether(2));
                    return [4 /*yield*/, sor.getSwaps(ETH_ADDRESS.toLowerCase(), tokenAddress.toLowerCase(), "swapExactIn", inputAmount)];
                case 3:
                    _a = _b.sent(), returnAmountV1 = _a[1], marketSpV1Scaled = _a[2];
                    if (!returnAmountV1.eq(0)) {
                        effectivePrice = inputAmount.div(returnAmountV1);
                        priceImpact = common_1.ether(effectivePrice.div(marketSpV1Scaled.div(Math.pow(10, 18))).toNumber()).sub(common_1.ether(1));
                        priceImpactRatio = common_1.preciseDiv(targetPriceImpact, priceImpact.mul(100));
                        return [2 /*return*/, {
                                exchange: types_1.exchanges.BALANCER,
                                size: common_1.preciseMul(fromBigNumberJS(returnAmountV1), priceImpactRatio).toString(),
                                data: "0x",
                            }];
                    }
                    return [2 /*return*/, {
                            exchange: types_1.exchanges.BALANCER,
                            size: constants_1.ZERO.toString(),
                            data: "0x",
                        }];
            }
        });
    });
}
exports.getBalancerV1Quote = getBalancerV1Quote;
function toBigNumberJS(value) {
    return new bignumber_js_1.BigNumber(value.toString());
}
function fromBigNumberJS(value) {
    return ethers_1.BigNumber.from(value.toString());
}
